import { type ReactNode } from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useUserGroupRuleValues } from 'src/graphql';
import { hasWorkflowManagementAccess } from 'src/graphql/entities/workflow/workflow.access';

/**
 * ProtectedPage cannot distinguish user grants from partner grants because the rule ids match, so the
 * Workflows settings routes are gated here on the user grant only.
 */
export const WorkflowsAccessGate = ({ redirectTo }: { redirectTo: string }): ReactNode => {
  const { userGroupRules } = useUserGroupRuleValues();
  const context = useOutletContext();
  const userRulesHydrated = Object.keys(userGroupRules).length > 0;

  if (!userRulesHydrated) {
    return null;
  }

  if (!hasWorkflowManagementAccess(userGroupRules)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet context={context} />;
};
